import _ from 'lodash';

import IntegrationsConstants from './IntegrationsConstants';

export function integrations(state = {}, action) {
    switch (action.type) {
        case IntegrationsConstants.INTEGRATION_RECEIVED:
            const newState = {
                ...state
            };

            const integration = action.payload;

            newState[integration.id] = {
                id: integration.id,
                type: integration.type,
                name: integration.name,
                about: integration.about,
                link: integration.link,
                picture: integration.picture,
                disconnected_at: integration.disconnected_at,
            };

            return newState;
        case IntegrationsConstants.INTEGRATION_REMOVED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    disconnected_at: (new Date()).toISOString().substring(0, 10),
                }
            };
            break;
        default:
            return state;
    }
}
